/* Mapping props to a function instead of the actual state helps ensure the data stays up to date. */
function refreshHeaderProps(state) {
	if (state.props) {
		return state.props;
	}
	return null;
}



export default {
	refreshHeaderProps,
};
